export enum StorageKey {
  Language = 'Language',
  Test = 'Test',
  Undefined = 'Undefined',
}
